/*
  Brands mega menu — open on hover (desktop only) — GTA Outdoors
  ------------------------------------------------------------------
  Trade/Dawn opens header mega menus on CLICK (native <details>/<summary>).
  This adds hover-to-open on desktop. We toggle the `open` attribute on the
  <details>, which fires the native `toggle` event the theme's HeaderMenu
  element (assets/details-disclosure.js) already listens for, so animation
  and header positioning keep working. Click-to-open remains as a fallback,
  and touch / mobile (drawer) is unaffected.
*/
(function () {
  var DESKTOP = '(min-width: 990px)';
  var CLOSE_DELAY = 150;

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  function bind(headerMenu) {
    var details = headerMenu.querySelector('details.mega-menu');
    if (!details) return;
    var summary = details.querySelector('summary');
    var closeTimer;

    function open() {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      if (!details.open) {
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    }

    function close() {
      if (!isDesktop()) return;
      closeTimer = setTimeout(function () {
        if (details.open) {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      }, CLOSE_DELAY);
    }

    headerMenu.addEventListener('mouseenter', open);
    headerMenu.addEventListener('mouseleave', close);
  }

  function init() {
    document.querySelectorAll('header-menu').forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
